import React from 'react'
import { useSelector } from 'react-redux'

const InfoScene = ({ data }) => {
    const infoData = useSelector(state => state.game.currentNarrativeObject.info[`${data}`])
    const { title, info, src } = infoData

    return (
        <article className='gray-container md:mb-0'>
            <div className='flex flex-col'>
                <h4 className='pb-2'>{title}</h4>
                <hr className='mb-4' />
                <p className='pb-2'>{info}</p>
                <hr className='mb-2' />
                <p className='src-legend p-0'><a href={src} target='_blank' rel="noopener noreferrer">fonte: {src}</a></p>
            </div>
        </article>
    )
}

export default InfoScene
